<app-libraries-page #libPage [isInModal]="true" [modalCategory]="modalCategory"></app-libraries-page>
